import { useQuery } from 'react-query';
import {
  UseSignaturePaymentENTOptions,
  UseSignaturePaymentENTParams,
  UseSignaturePaymentENTResponse,
} from './useSignaturePaymentENT.types';
import { querySignaturePaymentENT } from './useSignaturePaymentENT.query';

export const SIGNATURE_PAYMENT_ENT_QUERY_KEY = 'SIGNATURE_PAYMENT_ENT';

export const useSignaturePaymentENT = (
  params: UseSignaturePaymentENTParams,
  options?: UseSignaturePaymentENTOptions
) => {
  return useQuery<UseSignaturePaymentENTResponse, Error>(
    SIGNATURE_PAYMENT_ENT_QUERY_KEY,
    () => querySignaturePaymentENT(params),
    {
      ...options,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
